<template>
  <v-toolbar-items class="hidden-xs-only">
    <app-user-avatar v-if="user!==null" :key="avatarKey"></app-user-avatar>
    <app-login v-else></app-login>
  </v-toolbar-items>
</template>

<script>
import { mapGetters } from "vuex";
import Login from "@/components/header/userTabs/Login";
import UserAvatar from "@/components/header/userTabs/UserAvatar";

export default {
  name: "UserTabs",
  components: {
    appLogin: Login,
    appUserAvatar: UserAvatar
  },
  data() {
    return {
      avatarKey: 1
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  watch: {
    user: function() {
      this.avatarKey = this.avatarKey+1;
    }
  }
};
</script>
